import { IApplicationState } from '../../types/redux';

export const selectPath = (state: IApplicationState): string => {
  return state.path;
};
